export default {
  accessory: {
    product: [],
    variation: [
      {
        id: 'variation_finish',
        label: {
          en: 'Finish',
          es: 'Acabado'
        },
        visible: true
      }
    ]
  },
  bottle_filler: {
    product: [],
    variation: [
      {
        id: 'variation_refrigeration_option',
        label: {
          en: 'Refrigeration Option',
          es: 'Opción de refrigeración'
        },
        visible: true
      },
      {
        id: 'variation_filter_option',
        label: {
          en: 'Filter Option',
          es: 'Opción de filtro'
        },
        visible: true
      },
      {
        id: 'variation_finish',
        label: {
          en: 'Finish',
          es: 'Acabado'
        },
        visible: true
      }
    ]
  },
  closet_combo: {
    product: [
      {
        id: 'flushometer_product_product_line',
        label: {
          en: 'Product Line',
          es: 'Línea de Productos'
        },
        visible: true
      },
      {
        id: 'water_closet_product_mounting',
        label: {
          en: 'Fixture Mount',
          es: 'Montaje de Mueble de Baño'
        },
        visible: true
      },
      {
        id: 'water_closet_product_floor_mount_type',
        label: {
          en: 'Floor Mount Type',
          es: 'Tipo de Montaje al Piso'
        },
        visible: true
      },
      {
        id: 'flushometer_variation_fixture_connection',
        label: {
          en: 'Fixture Connection',
          es: 'Conexión de Mueble de Baño'
        },
        visible: true
      },
      {
        id: 'flushometer_variation_flush_volume',
        label: {
          en: 'Flush Volume',
          es: 'Volumen de Descarga'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ],
    variation: [
      {
        id: 'flushometer_product_product_line',
        label: {
          en: 'Product Line',
          es: 'Línea de Productos'
        },
        visible: false
      },
      {
        id: 'water_closet_product_mounting',
        label: {
          en: 'Fixture Mount',
          es: 'Montaje de Mueble de Baño'
        },
        visible: false
      },
      {
        id: 'water_closet_product_floor_mount_type',
        label: {
          en: 'Floor Mount Type',
          es: 'Tipo de Montaje al Piso'
        },
        visible: false
      },
      {
        id: 'flushometer_variation_fixture_connection',
        label: {
          en: 'Fixture Connection',
          es: 'Conexión de Mueble de Baño'
        },
        visible: false
      },
      {
        id: 'flushometer_variation_flush_volume',
        label: {
          en: 'Flush Volume',
          es: 'Volumen de Descarga'
        },
        visible: false
      },
      {
        id: 'variation_carbon_offset',
        label: {
          en: 'Carbon Offset',
          es: 'Compensación de Carbono'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: false
      }
    ]
  },
  faucet: {
    product: [
      {
        id: 'product_product_line',
        label: {
          en: 'Product Line',
          es: 'Línea de Productos'
        },
        visible: true
      },
      {
        id: 'product_power_type',
        label: {
          en: 'Power Type',
          es: 'Tipo de Energía'
        },
        visible: true
      },
      {
        id: 'variation_sensor_type',
        label: {
          en: 'Sensor Type',
          es: 'Tipo de Sensor'
        },
        visible: true
      },
      {
        id: 'variation_smart_faucet',
        label: {
          en: 'Smart Faucet',
          es: 'Llaves Inteligentes'
        },
        visible: true
      },
      {
        id: 'product_guided_handwashing_display',
        label: {
          en: 'Guided Handwashing Display',
          es: 'Guided Handwashing Display'
        },
        visible: true
      },
      {
        id: 'variation_flow_rate',
        label: {
          en: 'Flow Rate',
          es: 'Índice de Flujo'
        },
        visible: true
      },
      {
        id: 'product_body_type',
        label: {
          en: 'Body Type',
          es: 'Tipo de Cuerpo'
        },
        visible: true
      },
      {
        id: 'variation_mixer',
        label: {
          en: 'Mixer',
          es: 'Mezcladora'
        },
        visible: true
      },
      {
        id: 'product_mounting',
        label: {
          en: 'Mounting',
          es: 'Montaje'
        },
        visible: true
      },
      {
        id: 'variation_trim_plate',
        label: {
          en: 'Trim Plate (in)',
          es: 'Placa de Montaje (pulg)'
        },
        visible: true
      },
      {
        id: 'variation_control_access',
        label: {
          en: 'Control Access',
          es: 'Acceso de Control'
        },
        visible: true
      },
      {
        id: 'variation_finish',
        label: {
          en: 'Finish',
          es: 'Acabado'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ],
    variation: [
      {
        id: 'product_product_line',
        label: {
          en: 'Product Line',
          es: 'Línea de Productos'
        },
        visible: false
      },
      {
        id: 'product_power_type',
        label: {
          en: 'Power Type',
          es: 'Tipo de Energía'
        },
        visible: false
      },
      {
        id: 'product_body_type',
        label: {
          en: 'Body Type',
          es: 'Tipo de Cuerpo'
        }
      },
      {
        id: 'product_mounting',
        label: {
          en: 'Mounting',
          es: 'Montaje'
        },
        visible: false
      },
      {
        id: 'variation_sensor_type',
        label: {
          en: 'Sensor Type',
          es: 'Tipo de Sensor'
        },
        visible: true
      },
      {
        id: 'variation_flow_rate',
        label: {
          en: 'Flow Rate (gpm)',
          es: 'Índice de Flujo'
        },
        visible: true
      },
      {
        id: 'variation_spray_type',
        label: {
          en: 'Spray Type',
          es: 'Tipo de Rocío'
        },
        visible: true
      },
      {
        id: 'variation_finish',
        label: {
          en: 'Finish',
          es: 'Acabado'
        },
        visible: true
      },
      {
        id: 'variation_spout_type',
        label: {
          en: 'Spout Type',
          es: 'Tipo de Grifo'
        },
        visible: true
      },
      {
        id: 'variation_centerset',
        label: {
          en: 'Centerset',
          es: 'Juego Centrado'
        },
        visible: true
      },
      {
        id: 'variation_trim_plate',
        label: {
          en: 'Trim Plate (in)',
          es: 'Placa de Montaje (pulg)'
        },
        visible: true
      },
      {
        id: 'variation_control_access',
        label: {
          en: 'Control Access',
          es: 'Acceso de Control'
        },
        visible: true
      },
      {
        id: 'variation_mixer',
        label: {
          en: 'Mixer',
          es: 'Mezcladora'
        },
        visible: true
      },
      {
        id: 'variation_adapter',
        label: {
          en: 'Adapter',
          es: 'Adaptador'
        },
        visible: true
      },
      {
        id: 'variation_transformer',
        label: {
          en: 'Transformer',
          es: 'Transformador'
        },
        visible: true
      },
      {
        id: 'variation_timeout',
        label: {
          en: 'Timeout',
          es: 'Pausa'
        },
        visible: true
      },
      {
        id: 'variation_wash_station',
        label: {
          en: 'Wash Station',
          es: 'Estación de Lavado'
        },
        visible: true
      },
      {
        id: 'variation_water_control',
        label: {
          en: 'Water Control',
          es: 'Control de Agua'
        },
        visible: true
      },
      {
        id: 'variation_special_features',
        label: {
          en: 'Special Features',
          es: 'Características Especiales'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ]
  },
  faucet_soap_dispenser_combo: {
    product: [
      {
        id: 'faucet_variation_finish',
        label: {
          en: 'Finish',
          es: 'Acabado'
        },
        visible: true
      },
      {
        id: 'faucet_variation_flow_rate',
        label: {
          en: 'Flow Rate',
          es: 'Índice de Flujo'
        },
        visible: true
      },
      {
        id: 'soap_dispenser_product_soap_type',
        label: {
          en: 'Soap Type',
          es: 'Tipo de Jabón'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ],
    variation: [
      {
        id: 'faucet_variation_finish',
        label: {
          en: 'Finish',
          es: 'Acabado'
        },
        visible: true
      },
      {
        id: 'faucet_variation_flow_rate',
        label: {
          en: 'Flow Rate',
          es: 'Índice de Flujo'
        },
        visible: true
      },
      {
        id: 'soap_dispenser_product_soap_type',
        label: {
          en: 'Soap Type',
          es: 'Tipo de Jabón'
        },
        visible: false
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ]
  },
  flushometer: {
    product: [
      {
        id: 'variation_power_type',
        label: {
          en: 'Power Type',
          es: 'Tipo de Energía'
        },
        visible: true
      },
      {
        id: 'product_product_line',
        label: {
          en: 'Product Line',
          es: 'Línea de Productos'
        },
        visible: true
      },
      {
        id: 'variation_flush_volume',
        label: {
          en: 'Flush Volume (gpf)',
          es: 'Volumen de Descarga (gpd)'
        },
        visible: true
      },
      {
        id: 'variation_water_efficiency',
        label: {
          en: 'Water Efficiency',
          es: 'Eficiencia en el Consumo de Agua'
        },
        visible: true
      },
      {
        id: 'variation_finish',
        label: {
          en: 'Finish',
          es: 'Acabado'
        },
        visible: true
      },
      {
        id: 'product_activation',
        label: {
          en: 'Activation',
          es: 'Activación'
        },
        visible: true
      },
      {
        id: 'product_valve',
        label: {
          en: 'Valve',
          es: 'Válvula'
        },
        visible: true
      },
      {
        id: 'product_installation',
        label: {
          en: 'Installation',
          es: 'Instalación'
        },
        visible: true
      },
      {
        id: 'product_fixture_type',
        label: {
          en: 'Fixture Type',
          es: 'Tipo de Mueble de Baño'
        },
        visible: true
      },
      {
        id: 'variation_fixture_connection',
        label: {
          en: 'Fixture Connection',
          es: 'Conexión de Mueble de Baño'
        },
        visible: true
      },
      {
        id: 'product_sensor_line',
        label: {
          en: 'Sensor Line',
          es: 'Línea de Sensor'
        },
        visible: true
      },
      {
        id: 'variation_override',
        label: {
          en: 'Override',
          es: 'Sobrepaso'
        },
        visible: true
      },
      {
        id: 'product_standard',
        label: {
          en: 'Standard',
          es: 'Estándar'
        },
        visible: true
      },
      {
        id: 'product_hydraulic',
        label: {
          en: 'Hydraulic',
          es: 'Hidráulico'
        },
        visible: true
      },
      {
        id: 'product_specialty',
        label: {
          en: 'Specialty',
          es: 'Especialidad'
        },
        visible: true
      },
      {
        id: 'product_smart_flushometer',
        label: {
          en: 'Smart Flushometer',
          es: 'Smart Flushometer'
        },
        visible: true
      },
      {
        id: 'product_reclaimed_water',
        label: {
          en: 'Reclaimed Water',
          es: 'Agua Recuperada'
        },
        visible: true
      },
      {
        id: 'product_valve_body_material',
        label: {
          en: 'Valve Body Material',
          es: 'Valve Body Material'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ],
    variation: [
      {
        id: 'product_product_line',
        label: {
          en: 'Product Line',
          es: 'Línea de Productos'
        },
        visible: false
      },
      {
        id: 'product_activation',
        label: {
          en: 'Activation',
          es: 'Activación'
        },
        visible: false
      },
      {
        id: 'product_valve',
        label: {
          en: 'Valve',
          es: 'Válvula'
        },
        visible: false
      },
      {
        id: 'product_installation',
        label: {
          en: 'Installation',
          es: 'Instalación'
        },
        visible: false
      },
      {
        id: 'product_fixture_type',
        label: {
          en: 'Fixture Type',
          es: 'Tipo de Mueble de Baño'
        },
        visible: false
      },
      {
        id: 'variation_fixture_connection',
        label: {
          en: 'Fixture Connection',
          es: 'Conexión de Mueble de Baño'
        },
        visible: false
      },
      {
        id: 'product_sensor_line',
        label: {
          en: 'Sensor Line',
          es: 'Línea de Sensor'
        },
        visible: false
      },
      {
        id: 'product_standard',
        label: {
          en: 'Standard',
          es: 'Estándar'
        },
        visible: false
      },
      {
        id: 'product_specialty',
        label: {
          en: 'Specialty',
          es: 'Especialidad'
        },
        visible: false
      },
      {
        id: 'product_hydraulic',
        label: {
          en: 'Hydraulic',
          es: 'Hidráulico'
        },
        visible: false
      },
      {
        id: 'product_reclaimed_water',
        label: {
          en: 'Reclaimed Water',
          es: 'Aguas Recicladas'
        },
        visible: false
      },
      {
        id: 'product_valve_body_material',
        label: {
          en: 'Valve Body Material',
          es: 'Valve Body Material'
        },
        visible: false
      },
      {
        id: 'variation_flush_volume',
        label: {
          en: 'Flush Volume (gpf)',
          es: 'Volumen de Descarga (gpd)'
        },
        visible: true
      },
      {
        id: 'variation_finish',
        label: {
          en: 'Finish',
          es: 'Acabado'
        },
        visible: true
      },
      {
        id: 'variation_power_type',
        label: {
          en: 'Power Type',
          es: 'Tipo de Energía'
        },
        visible: true
      },
      {
        id: 'variation_bypass',
        label: {
          en: 'Bypass',
          es: 'Sobrepaso'
        },
        visible: true
      },
      {
        id: 'variation_l_dimension',
        label: {
          en: 'L Dimension',
          es: 'Dimensión L'
        },
        visible: true
      },
      {
        id: 'variation_wall_box',
        label: {
          en: 'Wall Box',
          es: 'Caja de Muro'
        },
        visible: true
      },
      {
        id: 'variation_handle',
        label: {
          en: 'Handle',
          es: 'Manija'
        },
        visible: true
      },
      {
        id: 'variation_push_button',
        label: {
          en: 'Push Button',
          es: 'Botón'
        },
        visible: true
      },
      {
        id: 'variation_override',
        label: {
          en: 'Override',
          es: 'Sobrepaso'
        },
        visible: true
      },
      {
        id: 'variation_water_efficiency',
        label: {
          en: 'Water Efficiency',
          es: 'Eficiencia en el Consumo de Agua'
        },
        visible: true
      },
      {
        id: 'variation_high_efficiency',
        label: {
          en: 'High Efficiency',
          es: 'Alta Eficiencia'
        },
        visible: true
      },
      {
        id: 'variation_control_stop',
        label: {
          en: 'Control Stop',
          es: 'Válvula de Retención'
        },
        visible: true
      },
      {
        id: 'variation_tailpiece',
        label: {
          en: 'Tailpiece',
          es: 'Boquilla'
        },
        visible: true
      },
      {
        id: 'variation_inlet',
        label: {
          en: 'Inlet',
          es: 'Entrada'
        },
        visible: true
      },
      {
        id: 'variation_vacuum_breaker',
        label: {
          en: 'Vacuum Breaker',
          es: 'Rompe-Vacío'
        },
        visible: true
      },
      {
        id: 'variation_offset',
        label: {
          en: 'Offset (in)',
          es: 'Compensación (pulg)'
        },
        visible: true
      },
      {
        id: 'variation_outlet_tube',
        label: {
          en: 'Outlet Tube',
          es: 'Tubo de Salida'
        },
        visible: true
      },
      {
        id: 'variation_fitting',
        label: {
          en: 'Fitting',
          es: 'Conector'
        },
        visible: true
      },
      {
        id: 'variation_adapter',
        label: {
          en: 'Adapter',
          es: 'Adaptador'
        },
        visible: true
      },
      {
        id: 'variation_bumper',
        label: {
          en: 'Bumper',
          es: 'Tope'
        },
        visible: true
      },
      {
        id: 'variation_pipe_support',
        label: {
          en: 'Pipe Support',
          es: 'Soporte de Tubo'
        },
        visible: true
      },
      {
        id: 'variation_voltage',
        label: {
          en: 'Voltage',
          es: 'Voltaje'
        },
        visible: true
      },
      {
        id: 'variation_special_features',
        label: {
          en: 'Special Features',
          es: 'Características Especiales'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ]
  },
  gravity_toilet: {
    product: [
      {
        id: 'variation_sloantec_glaze',
        label: {
          en: 'SloanTec® Hydrophobic Glaze',
          es: 'Esmalte Hidrorepelente SloanTec®'
        },
        visible: true
      }
    ],
    variation: [
      {
        id: 'variation_sloantec_glaze',
        label: {
          en: 'SloanTec® Hydrophobic Glaze',
          es: 'Esmalte Hidrorepelente SloanTec®'
        },
        visible: true
      }
    ]
  },
  hand_dryer: {
    product: [
      {
        id: 'product_product_line',
        label: {
          en: 'Product Line',
          es: 'Línea de Productos'
        },
        visible: true
      },
      {
        id: 'variation_finish',
        label: {
          en: 'Finish',
          es: 'Acabado'
        },
        visible: true
      },
      {
        id: 'product_voltage',
        label: {
          en: 'Voltage',
          es: 'Voltaje'
        },
        visible: true
      },
      {
        id: 'product_wattage',
        label: {
          en: 'Wattage',
          es: 'Vataje'
        },
        visible: true
      },
      {
        id: 'product_high_efficiency',
        label: {
          en: 'High Efficiency',
          es: 'Alta Eficiencia'
        },
        visible: true
      },
      {
        id: 'product_activation',
        label: {
          en: 'Activation',
          es: 'Activación'
        },
        visible: true
      },
      {
        id: 'product_mounting',
        label: {
          en: 'Mounting',
          es: 'Montaje'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ],
    variation: [
      {
        id: 'product_product_line',
        label: {
          en: 'Product Line',
          es: 'Línea de Productos'
        },
        visible: false
      },
      {
        id: 'product_activation',
        label: {
          en: 'Activation',
          es: 'Activación'
        },
        visible: false
      },
      {
        id: 'product_voltage',
        label: {
          en: 'Voltage',
          es: 'Voltaje'
        },
        visible: false
      },
      {
        id: 'product_wattage',
        label: {
          en: 'Wattage',
          es: 'Vataje'
        },
        visible: false
      },
      {
        id: 'product_high_efficiency',
        label: {
          en: 'High Efficiency',
          es: 'Alta Eficiencia'
        },
        visible: false
      },
      {
        id: 'product_mounting',
        label: {
          en: 'Mounting',
          es: 'Montaje'
        },
        visible: false
      },
      {
        id: 'variation_finish',
        label: {
          en: 'Finish',
          es: 'Acabado'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ]
  },
  health_faucet: {
    product: [],
    variation: []
  },
  lavatory: {
    product: [
      {
        id: 'product_configuration',
        label: {
          en: 'Configuration',
          es: 'Configuración'
        },
        visible: true
      },
      {
        id: 'product_lavatory_type',
        label: {
          en: 'Lavatory Type',
          es: 'Montaje'
        },
        visible: true
      },
      {
        id: 'product_centerset',
        label: {
          en: 'Centerset',
          es: 'Juego Centrado'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ],
    variation: [
      {
        id: 'product_configuration',
        label: {
          en: 'Configuration',
          es: 'Configuración'
        },
        visible: false
      },
      {
        id: 'product_mounting',
        label: {
          en: 'Mounting',
          es: 'Montaje'
        },
        visible: false
      },
      {
        id: 'product_centerset',
        label: {
          en: 'Centerset',
          es: 'Juego Centrado'
        },
        visible: false
      },
      {
        id: 'variation_sloantec_glaze',
        label: {
          en: 'SloanTec® Hydrophobic Glaze',
          es: 'Esmalte Hidrorepelente SloanTec®'
        },
        visible: true
      },
      {
        id: 'variation_carbon_offset',
        label: {
          en: 'Carbon Offset',
          es: 'Compensación de Carbono'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ]
  },
  mirror: {
    product: [],
    variation: [
      {
        id: 'variation_mirror_size',
        label: {
          en: 'Mirror Size',
          es: 'Tamaño del espejo'
        },
        visible: true
      },
      {
        id: 'variation_finish',
        label: {
          en: 'Finish',
          es: 'Acabado'
        },
        visible: true
      }
    ]
  },
  pressure_assist_water_closet: {
    product: [
      {
        id: 'product_floor_mount_type',
        label: {
          en: 'Floor Mount Type',
          es: 'Tipo de Montaje al Piso'
        },
        visible: true
      },
      {
        id: 'product_flush_volume',
        label: {
          en: 'Flush Volume',
          es: 'Volumen de Descarga'
        },
        visible: true
      },
      {
        id: 'variation_sloantec_glaze',
        label: {
          en: 'SloanTec® Hydrophobic Glaze',
          es: 'Esmalte Hidrorepelente SloanTec®'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ],
    variation: [
      {
        id: 'product_floor_mount_type',
        label: {
          en: 'Floor Mount Type',
          es: 'Tipo de Montaje al Piso'
        },
        visible: false
      },
      {
        id: 'variation_fixture_connection',
        label: {
          en: 'Fixture Connection',
          es: 'Conexión de Mueble de Baño'
        },
        visible: false
      },
      {
        id: 'product_flush_volume',
        label: {
          en: 'Flush Volume',
          es: 'Volumen de Descarga'
        },
        visible: false
      },
      {
        id: 'variation_sloantec_glaze',
        label: {
          en: 'SloanTec® Hydrophobic Glaze',
          es: 'Esmalte Hidrorepelente SloanTec®'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ]
  },
  showerhead: {
    product: [
      {
        id: 'product_showerhead_type',
        label: {
          en: 'Type',
          es: 'Tipo'
        },
        visible: true
      },
      {
        id: 'variation_flow_rate',
        label: {
          en: 'Flow Rate',
          es: 'Índice de Flujo'
        },
        visible: true
      },
      {
        id: 'variation_pwt',
        label: {
          en: 'PWT',
          es: 'PWT'
        },
        visible: true
      }
    ],
    variation: [
      {
        id: 'product_showerhead_type',
        label: {
          en: 'Type',
          es: 'Tipo'
        },
        visible: false
      },
      {
        id: 'variation_pwt',
        label: {
          en: 'PWT',
          es: 'PWT'
        },
        visible: false
      },
      {
        id: 'variation_flow_rate',
        label: {
          en: 'Flow Rate',
          es: 'Índice de Flujo'
        },
        visible: true
      },
      {
        id: 'variation_special_features',
        label: {
          en: 'Special Features',
          es: 'Características Especiales'
        },
        visible: true
      },
      {
        id: 'variation_set_screws_included',
        label: {
          en: 'Set Screws Included',
          es: 'Tornillos de Ajuste Incluidos'
        },
        visible: true
      }
    ]
  },
  sink: {
    product: [
      {
        id: 'product_product_line',
        label: {
          en: 'Product Line',
          es: 'Línea de Productos'
        },
        visible: true
      },
      {
        id: 'product_material',
        label: {
          en: 'Material',
          es: 'Material'
        },
        visible: true
      },
      {
        id: 'product_stations',
        label: {
          en: 'Stations',
          es: 'Estaciones'
        },
        visible: true
      },
      {
        id: 'product_variable_width',
        label: {
          en: 'Variable Size',
          es: 'Tamaño Variable'
        },
        visible: true
      },
      {
        id: 'product_mounting',
        label: {
          en: 'Mounting',
          es: 'Montaje'
        },
        visible: true
      },
      {
        id: 'product_verticals',
        label: {
          en: 'Verticals',
          es: 'Verticales'
        },
        visible: true
      },
      {
        id: 'product_building_types',
        label: {
          en: 'Building Types',
          es: 'Tipos de Edificios'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ],
    variation: [
      {
        id: 'product_product_line',
        label: {
          en: 'Product Line',
          es: 'Línea de Productos'
        },
        visible: false
      },
      {
        id: 'product_stations',
        label: {
          en: 'Stations',
          es: 'Estaciones'
        },
        visible: false
      },
      {
        id: 'product_mounting',
        label: {
          en: 'Mounting',
          es: 'Montaje'
        },
        visible: false
      },
      {
        id: 'product_material',
        label: {
          en: 'Material',
          es: 'Material'
        },
        visible: false
      },
      {
        id: 'product_variable_width',
        label: {
          en: 'Variable Size',
          es: 'Tamaño Variable'
        },
        visible: false
      },
      {
        id: 'product_verticals',
        label: {
          en: 'Verticals',
          es: 'Verticales'
        },
        visible: false
      },
      {
        id: 'product_building_types',
        label: {
          en: 'Building Types',
          es: 'Tipos de Edificios'
        },
        visible: false
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: false
      }
    ]
  },
  soap: {
    variation: []
  },
  soap_dispenser: {
    product: [
      {
        id: 'product_product_line',
        label: {
          en: 'Product Line',
          es: 'Línea de Productos'
        },
        visible: true
      },
      {
        id: 'variation_finish',
        label: {
          en: 'Finish',
          es: 'Acabado'
        },
        visible: true
      },
      {
        id: 'product_dispenser_type',
        label: {
          en: 'Dispenser Type',
          es: 'Tipo de Despachador'
        },
        visible: true
      },
      {
        id: 'product_soap_type',
        label: {
          en: 'Soap Type',
          es: 'Tipo de Jabón'
        },
        visible: true
      },
      {
        id: 'product_power_type',
        label: {
          en: 'Power Type',
          es: 'Tipo de Energía'
        },
        visible: true
      }
    ],
    variation: [
      {
        id: 'product_product_line',
        label: {
          en: 'Product Line',
          es: 'Línea de Productos'
        },
        visible: false
      },
      {
        id: 'product_dispenser_type',
        label: {
          en: 'Dispenser Type',
          es: 'Tipo de Despachador'
        },
        visible: false
      },
      {
        id: 'product_power_type',
        label: {
          en: 'Power Type',
          es: 'Tipo de Energía'
        },
        visible: false
      },
      {
        id: 'product_soap_type',
        label: {
          en: 'Soap Type',
          es: 'Tipo de Jabón'
        },
        visible: false
      },
      {
        id: 'variation_finish',
        label: {
          en: 'Finish',
          es: 'Acabado'
        },
        visible: true
      },
      {
        id: 'variation_adapter',
        label: {
          en: 'Adapter',
          es: 'Adaptador'
        },
        visible: true
      },
      {
        id: 'variation_transformer',
        label: 'Transformer',
        visible: true
      }
    ]
  },
  urinal: {
    product: [
      {
        id: 'product_flush_method',
        label: {
          en: 'Flush Method',
          es: 'Método de Descarga'
        },
        visible: true
      },
      {
        id: 'product_urinal_type',
        label: {
          en: 'Urinal Type',
          es: 'Tipo de Mingitorio'
        },
        visible: true
      },
      {
        id: 'product_fixture_connection',
        label: {
          en: 'Fixture Connection',
          es: 'Conexión de Mueble de Baño'
        },
        visible: true
      },
      {
        id: 'product_flush_volume',
        label: {
          en: 'Flush Volume',
          es: 'Volumen de Descarga'
        },
        visible: true
      },
      {
        id: 'variation_sloantec_glaze',
        label: {
          en: 'SloanTec® Hydrophobic Glaze',
          es: 'Esmalte Hidrorepelente SloanTec®'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ],
    variation: [
      {
        id: 'product_flush_method',
        label: {
          en: 'Flush Method',
          es: 'Esmalte Hidrorepelente SloanTec®'
        },
        visible: false
      },
      {
        id: 'product_urinal_type',
        label: {
          en: 'Urinal Type',
          es: 'Tipo de Mingitorio'
        },
        visible: false
      },
      {
        id: 'variation_fixture_connection',
        label: {
          en: 'Fixture Connection',
          es: 'Conexión de Mueble de Baño'
        },
        visible: false
      },
      {
        id: 'product_flush_volume',
        label: {
          en: 'Flush Volume',
          es: 'Volumen de Descarga'
        },
        visible: false
      },
      {
        id: 'variation_sloantec_glaze',
        label: {
          en: 'SloanTec® Hydrophobic Glaze',
          es: 'Esmalte Hidrorepelente SloanTec®'
        },
        visible: true
      },
      {
        id: 'variation_carbon_offset',
        label: {
          en: 'Carbon Offset',
          es: 'Compensación de Carbono'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: false
      }
    ]
  },
  urinal_combo: {
    product: [
      {
        id: 'flushometer_product_product_line',
        label: {
          en: 'Product Line',
          es: 'Línea de Productos'
        },
        visible: true
      },
      {
        id: 'urinal_product_urinal_type',
        label: {
          en: 'Urinal Type',
          es: 'Tipo de Mingitorio'
        },
        visible: true
      },
      {
        id: 'flushometer_variation_fixture_connection',
        label: {
          en: 'Fixture Connection',
          es: 'Conexión de Mueble de Baño'
        },
        visible: true
      },
      {
        id: 'flushometer_variation_flush_volume',
        label: {
          en: 'Flush Volume',
          es: 'Volumen de Descarga'
        },
        visible: true
      },
      {
        id: 'urinal_product_retrofit',
        label: {
          en: 'Retrofit',
          es: 'Retrofit'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ],
    variation: [
      {
        id: 'flushometer_product_product_line',
        label: {
          en: 'Product Line',
          es: 'Línea de Productos'
        },
        visible: false
      },
      {
        id: 'urinal_product_urinal_type',
        label: {
          en: 'Urinal Type',
          es: 'Tipo de Mingitorio'
        },
        visible: false
      },
      {
        id: 'flushometer_variation_fixture_connection',
        label: {
          en: 'Fixture Connection',
          es: 'Conexión de Mueble de Baño'
        },
        visible: false
      },
      {
        id: 'flushometer_variation_flush_volume',
        label: {
          en: 'Flush Volume',
          es: 'Volumen de Descarga'
        },
        visible: false
      },
      {
        id: 'urinal_product_retrofit',
        label: {
          en: 'Retrofit',
          es: 'Retrofit'
        },
        visible: false
      },
      {
        id: 'variation_carbon_offset',
        label: {
          en: 'Carbon Offset',
          es: 'Compensación de Carbono'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ]
  },
  water_closet: {
    product: [
      {
        id: 'product_mounting',
        label: {
          en: 'Fixture Mount',
          es: 'Montaje de Mueble de Baño'
        },
        visible: true
      },
      {
        id: 'product_floor_mount_type',
        label: {
          en: 'Floor Mount Type',
          es: 'Tipo de Montaje al Piso'
        },
        visible: true
      },
      {
        id: 'product_fixture_connection',
        label: {
          en: 'Fixture Connection',
          es: 'Conexión de Mueble de Baño'
        },
        visible: true
      },
      {
        id: 'product_flush_volume',
        label: {
          en: 'Flush Volume',
          es: 'Volumen de Descarga'
        },
        visible: true
      },
      {
        id: 'variation_sloantec_glaze',
        label: {
          en: 'SloanTec® Hydrophobic Glaze',
          es: 'Esmalte Hidrorepelente SloanTec®'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ],
    variation: [
      {
        id: 'product_mounting',
        label: {
          en: 'Fixture Mount',
          es: 'Montaje de Mueble de Baño'
        },
        visible: false
      },
      {
        id: 'product_fixture_connection',
        label: {
          en: 'Fixture Connection',
          es: 'Conexión de Mueble de Baño'
        },
        visible: false
      },
      {
        id: 'product_floor_mount_type',
        label: {
          en: 'Floor Mount Type',
          es: 'Tipo de Montaje al Piso'
        },
        visible: false
      },
      {
        id: 'product_flush_volume',
        label: {
          en: 'Flush Volume',
          es: 'Volumen de Descarga'
        },
        visible: false
      },
      {
        id: 'variation_sloantec_glaze',
        label: {
          en: 'SloanTec® Hydrophobic Glaze',
          es: 'Esmalte Hidrorepelente SloanTec®'
        },
        visible: true
      },
      {
        id: 'variation_carbon_offset',
        label: {
          en: 'Carbon Offset',
          es: 'Compensación de Carbono'
        },
        visible: true
      },
      {
        id: 'variation_bed_pan_lugs',
        label: {
          en: 'Bed Pan Lugs',
          es: 'Agarraderas de Lavador de Cómodo'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ]
  },
  sustainable: {
    product: [
      {
        id: 'variation_type',
        label: {
          en: 'Product Type',
          es: 'Product Type'
        },
        visible: true
      },
      {
        id: 'variation_compliances_certifications',
        label: {
          en: 'Compliances & Certifications',
          es: 'Cumplimientos y Certificaciones'
        },
        visible: true
      }
    ]
  },
  part: {
    product: [],
    variation: []
  }
};
